import React, { useEffect, useState } from "react";
import { Form } from "antd";
import Company from "../../../api/Company";
import { useTranslation } from "react-i18next";
import FormInput from "../../atoms/FormInput";
import FormSelect from "../../atoms/FormSelect";

const FormRegion = ({ region = null }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [companies, setCompanies] = useState([]);
  const [name, setName] = useState(region?.name || "");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load companies on mount
  useEffect(() => {
    loadCompanies();
  }, []);

  // Update form values when region changes
  useEffect(() => {
    if (region) {
      setName(region.name);
      if (region.company) {
        const companyOption = {
          value: region.company.id,
          label: region.company.name,
        };
        setSelectedCompany(companyOption);
        form.setFieldsValue({
          name: region.name,
          company_id: companyOption
        });
      }
    }
  }, [region, form]);

  const loadCompanies = () => {
    setLoading(true);
    Company.getAll()
      .then((response) => {
        setCompanies(response.data.data);
      })
      .catch((error) => {
        console.error("Error loading companies:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="w-full">
      <Form.Item 
        name="name" 
        initialValue={region?.name}
        rules={[{ required: true, message: t("common.name-is-required") }]}
      >
        <FormInput
          name="name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
          darmo={true}
          label={t("common.name")}
          placeholder={t("regions.add-a-region-name")}
        />
      </Form.Item>
      <Form.Item 
        name="company_id"
        initialValue={
          region?.company
            ? {
                value: region.company.id,
                label: region.company.name,
              }
            : undefined
        }
        rules={[{ required: true, message: t("common.company-is-required") }]}
      >
        <FormSelect
          name="company_id"
          label={t("common.company")}
          placeholder={loading ? "Loading companies..." : "Select Company"}
          value={selectedCompany}
          onChange={(e) => {
            setSelectedCompany(e);
          }}
          options={companies.map((_company) => ({
            value: _company.id,
            label: _company.name,
          }))}
          isLoading={loading}
          darmo={true}
        />
      </Form.Item>
    </div>
  );
};

export default FormRegion;
